import Service from "../../../Services/index";
import moment from "moment";

const SocialSecurity = {
    namespaced: true,
    state: {
        taxPersonList:[],
        SocialList:[],
        form_tax:{
            id: null,
            salary_min : "",
            salary_max : "",
            amount : "",
            unit_id : 1,
        },
        form_security : {
          id : null,
          rate : '',
          rate_percent : '',
          date : '',
          minimun_rate : '',
        },
    },
    mutations: {
        GET_TAX_PERSON_TABLE: (state, res) => {
            state.taxPersonList = res;
        },
        GET_SOCIAL_SECURITY_BY_ID: (state, res) => {
            state.form_security = res;
        },
        CLEAR_FORM_DATA : (state)=>{
            state.form_tax = {
                id: null,
                salary_min : "",
                salary_max : "",
                amount : "",
                unit_id : 1,
            }
            state.form_security = {
                id : null,
                rate : '',
                rate_percent : '',
                date : '',
                minimun_rate : '',
            }
        },
        GET_TAX_PERSON_RATE_FORM : (state,res)=>{
            state.form_tax = res;
        }
    },
    actions: {
        setSocialSecurity({commit}){
            return Service.SettingSocialSecurity.getSocialSecurity().then(res=>{
                commit("GET_TAX_PERSON_TABLE",res);
            });
        },
        saveSocialSecurity({commit},{id,data}){
            if(!id){
                return Service.SettingSocialSecurity.createSocialSecurity(data);
            }
            else{
                return Service.SettingSocialSecurity.updateSocialSecurity(id,data);
            }
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        showSocialSecurityByID({commit},id){
            return Service.SettingSocialSecurity.showSocialSecurity(id).then(res=>{
                commit("GET_SOCIAL_SECURITY_BY_ID",res);
            });
        },
        deleteSocialSecurity({ commit }, id) {
            return Service.SettingSocialSecurity.deleteSocialSecurity(id);
        },
        //taxRate
        getTaxPerson({commit},page=1){
            return Service.SettingSocialSecurity.getRateTaxPerson(page);
        },

        saveTaxPerson({commit},{id,data}){
            if(!id){
                return Service.SettingSocialSecurity.createRateTaxPerson(data);
            }else{
                return Service.SettingSocialSecurity.updateRateTaxPerson(id,data);
            }
        },
        showTaxPerson({commit},id){
            return Service.SettingSocialSecurity.showRateTaxPerson(id).then(res=>{
                commit('GET_TAX_PERSON_RATE_FORM',res);
            });
        },
        deleteTaxPerson({commit},id){
            return Service.SettingSocialSecurity.deleteTaxPerson(id);
        }

    }
};

export default SocialSecurity;
